<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">数据中心</Breadcrumb-item>
        <Breadcrumb-item>数据汇总列表</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="50" :show-message="false" label-position="left">
        <Row :gutter="32">
          <Col :span="8" >
            <Form-item label="时间">
              <Row>
                <Col span="11">
                  <Date-picker type="date" format="yyyy" value-format="yyyy" placeholder="请选择年份" v-model="queryParam.paramYear" style="width: 100%;" />
                </Col>
                <Col span="2" style="text-align: center">-</Col>
                <Col span="11">
                  <Date-picker type="date" format="MM" value-format="MM" placeholder="请选择月份" v-model="queryParam.paramMonth" style="width: 100%;" />
                </Col>
              </Row>
            </Form-item>
          </Col>
          <Col :span="2">
              <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                      @click="search" >搜索</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <div class="btn-wrap">
      <Button type="primary" :loading="exportLoading" :disable="exportLoading" icon="search"
        @click="exportData">导出
      </Button>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/dataCenter/statisticsGatherList"
          :params="queryParam" :onLoading="onLoading"></List>
  </div>
</template>

<script>
    export default {
      components: {

      },
      name: 'statisticsGatherList',
      data () {
        return {
          exportLoading: false,
          searchLoading: false,
          reload: 0,
          queryParam: {
            paramYear: null,
            paramMonth: null
          },
          title: [
            {
              title: '日期',
              width: 90,
              align: 'center',
              key: 'statisticalDate'
            },
            {
              title: '学生总数(常规+冻结)',
              align: 'center',
              width: 120,
              key: 'studentTotalCount',
            },
            {
              title: '冻结数',
              width: 80,
              align: 'center',
              key: 'studentClosedCount'
            },
            {
              title: '新增量',
              width: 80,
              align: 'center',
              key: 'studentNewMonthCount'
            },
            {
              title: '预估结课量',
              width: 110,
              align: 'center',
              key: 'estimateEndStudentCount'
            },
            {
              title: '实际结课量',
              width: 110,
              align: 'center',
              key: 'actualEndStudentCount'
            },
            {
              title: '退费新生数',
              width: 110,
              align: 'center',
              key: 'newRefundCount'
            },
            {
              title: '退费常规生数',
              width: 125,
              align: 'center',
              key: 'routineRefundCount'
            },
            {
              title: '一对一课时',
              width: 110,
              align: 'center',
              key: 'enCount'
            },
            {
              title: '提前请假(六小时前)',
              width: 120,
              align: 'center',
              key: 'studentAskLeaveCount'
            },
            {
              title: '临时请假(六小时后)',
              width: 120,
              align: 'center',
              key: 'studentOnLeaveCount'
            },
            {
              title: '缺席数',
              width: 80,
              align: 'center',
              key: 'studentAbsentCount'
            },
            {
              title: '补课数(不计课时)',
              width: 100,
              align: 'center',
              key: 'makeUpCount'
            },
            {
              title: '朋友圈赠课数',
              width: 100,
              align: 'center',
              key: 'circleGiveCourseCount'
            },
            {
              title: '补贴课时',
              width: 95,
              align: 'center',
              key: 'otherGiveCourseCount'
            },
            {
              title: '续费业绩(元)',
              width: 120,
              align: 'center',
              key: 'renewalPerformance'
            },
            {
              title: '学导人数',
              width: 95,
              align: 'center',
              key: 'studyConsultantCount'
            },
            {
              title: '人效(元)',
              width: 120,
              align: 'center',
              key: 'peopleEfficiency'
            },
            {
              title: '转化率',
              width: 100,
              align: 'center',
              key: 'percentConversion'
            },
            {
              title: '新生退费总金额(元)',
              width: 120,
              align: 'center',
              key: 'newRefundSum'
            },
            {
              title: '常规生退费总金额(元)',
              width: 120,
              align: 'center',
              key: 'routineRefundSum'
            }
          ]
        }
      },
      mounted: function () {
        this.init()
      },
      created: function () {
        this.init()
      },
      methods: {
        init () {

        },
        exportData () {
          this.exportLoading = true
          this.$http.get('/dataCenter/statisticsGather/exportExcel', {responseType: 'arraybuffer', params: this.queryParam}).then((response) => {
            if (response.data) {
              let blob = new Blob([response.data], {type: 'text/csv'})
              let link = document.createElement('a')
              link.target = '_blank'
              link.href = window.URL.createObjectURL(blob)
              link.download = '课耗统计.csv'
              link.click()
              this.exportLoading = false
            } else {
              this.$Message.error(response.msg)
            }
          }).catch((e) => {
            this.exportLoading = false
          })
        },
        search () {
          this.reload = new Date().getTime()
        },
        onLoading (loading) {
          this.searchLoading = loading
        },
      },
    }
</script>


<style lang="less" scoped>
  .btn-wrap {
    text-align: right;
    margin-top: 24px;
    margin-bottom: 12px;
  }
</style>


// WEBPACK FOOTER //
// StatisticsGatherList.vue?4e6c1a49